export default "__VITE_ASSET__BGB$AD$B__"